import { useForm, type UseFormReturn } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import { Input } from '../../components/ui/Input'
import { Select } from '../../components/ui/Select'
import { Textarea } from '../../components/ui/Textarea'
import { BRANCHEN } from '../../types'
import type { Kunde } from '../../types'

const schema = z.object({
  name: z.string().min(2, 'Name erforderlich'),
  firma: z.string().optional(),
  adresse: z.string().optional(),
  plz: z.string().optional(),
  ort: z.string().optional(),
  kanton: z.string().optional(),
  telefon: z.string().optional(),
  email: z.string().email('Ungültige E-Mail').optional().or(z.literal('')),
  branche: z.string().optional(),
  notizen: z.string().optional(),
})

type FormData = z.infer<typeof schema>

export function useKundeForm(defaults?: Partial<Kunde>) {
  return useForm<FormData>({
    resolver: zodResolver(schema),
    defaultValues: {
      name: defaults?.name ?? '',
      firma: defaults?.firma ?? '',
      adresse: defaults?.adresse ?? '',
      plz: defaults?.plz ?? '',
      ort: defaults?.ort ?? '',
      kanton: defaults?.kanton ?? '',
      telefon: defaults?.telefon ?? '',
      email: defaults?.email ?? '',
      branche: defaults?.branche ?? '',
      notizen: defaults?.notizen ?? '',
    },
  })
}

interface KundeFormFieldsProps {
  form: UseFormReturn<FormData>
}

export function KundeFormFields({ form }: KundeFormFieldsProps) {
  const { register, formState: { errors } } = form

  const kantone = ['AG','AI','AR','BE','BL','BS','FR','GE','GL','GR','JU','LU','NE','NW','OW','SG','SH','SO','SZ','TG','TI','UR','VD','VS','ZG','ZH']

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-2 gap-3">
        <div className="col-span-2">
          <Input label="Ansprechperson" placeholder="Max Muster" error={errors.name?.message} required {...register('name')} />
        </div>
        <div className="col-span-2">
          <Input label="Firma" placeholder="Firma GmbH" {...register('firma')} />
        </div>
      </div>
      <Input label="Adresse" placeholder="Musterstrasse 1" {...register('adresse')} />
      <div className="grid grid-cols-3 gap-3">
        <Input label="PLZ" placeholder="8000" {...register('plz')} />
        <div className="col-span-2">
          <Input label="Ort" placeholder="Zürich" {...register('ort')} />
        </div>
      </div>
      <Select
        label="Kanton"
        options={kantone.map((k) => ({ value: k, label: k }))}
        placeholder="Kanton wählen"
        {...register('kanton')}
      />
      <Input label="Telefon" type="tel" placeholder="+41 44 000 00 00" {...register('telefon')} />
      <Input label="E-Mail" type="email" placeholder="info@firma.ch" error={errors.email?.message} {...register('email')} />
      <Select
        label="Branche"
        options={BRANCHEN.map((b) => ({ value: b, label: b }))}
        placeholder="Branche wählen"
        {...register('branche')}
      />
      <Textarea label="Notizen" placeholder="Interne Notizen..." rows={3} {...register('notizen')} />
    </div>
  )
}
